import { fetchHeroContent, fetchCategories } from '../util/api/sanity';
import { storableError } from '../util/errors';
import { buildCategoryTree } from '../util/categoryTreeUtils';

// ================ Action types ================ //

export const FETCH_HERO_CONTENT_REQUEST = 'app/sanityContent/FETCH_HERO_CONTENT_REQUEST';
export const FETCH_HERO_CONTENT_SUCCESS = 'app/sanityContent/FETCH_HERO_CONTENT_SUCCESS';
export const FETCH_HERO_CONTENT_ERROR = 'app/sanityContent/FETCH_HERO_CONTENT_ERROR';

export const FETCH_CATEGORIES_REQUEST = 'app/sanityContent/FETCH_CATEGORIES_REQUEST';
export const FETCH_CATEGORIES_SUCCESS = 'app/sanityContent/FETCH_CATEGORIES_SUCCESS';
export const FETCH_CATEGORIES_ERROR = 'app/sanityContent/FETCH_CATEGORIES_ERROR';

// ================ Reducer ================ //

const initialState = {
  heroContent: null,
  fetchHeroContentInProgress: false,
  fetchHeroContentError: null,
  categories: [],
  categoryTree: [],
  fetchCategoriesInProgress: false,
  fetchCategoriesError: null,
};

export default function sanityContentReducer(state = initialState, action = {}) {
  const { type, payload } = action;

  switch (type) {
    case FETCH_HERO_CONTENT_REQUEST:
      return {
        ...state,
        fetchHeroContentInProgress: true,
        fetchHeroContentError: null,
      };

    case FETCH_HERO_CONTENT_SUCCESS:
      return {
        ...state,
        heroContent: payload,
        fetchHeroContentInProgress: false,
      };

    case FETCH_HERO_CONTENT_ERROR:
      return {
        ...state,
        fetchHeroContentInProgress: false,
        fetchHeroContentError: payload,
      };

    case FETCH_CATEGORIES_REQUEST:
      return {
        ...state,
        fetchCategoriesInProgress: true,
        fetchCategoriesError: null,
      };

    case FETCH_CATEGORIES_SUCCESS:
      return {
        ...state,
        categories: payload,
        categoryTree: buildCategoryTree(payload),
        fetchCategoriesInProgress: false,
      };

    case FETCH_CATEGORIES_ERROR:
      return {
        ...state,
        fetchCategoriesInProgress: false,
        fetchCategoriesError: payload,
      };

    default:
      return state;
  }
}

// ================ Action creators ================ //

export const fetchHeroContentRequest = () => ({
  type: FETCH_HERO_CONTENT_REQUEST,
});

export const fetchHeroContentSuccess = heroContent => ({
  type: FETCH_HERO_CONTENT_SUCCESS,
  payload: heroContent,
});

export const fetchHeroContentError = error => ({
  type: FETCH_HERO_CONTENT_ERROR,
  payload: error,
  error: true,
});

export const fetchCategoriesRequest = () => ({
  type: FETCH_CATEGORIES_REQUEST,
});

export const fetchCategoriesSuccess = categories => ({
  type: FETCH_CATEGORIES_SUCCESS,
  payload: categories,
});

export const fetchCategoriesError = error => ({
  type: FETCH_CATEGORIES_ERROR,
  payload: error,
  error: true,
});

// ================ Thunks ================ //

export const loadHeroContent = () => (dispatch, getState, sdk) => {
  dispatch(fetchHeroContentRequest());

  return fetchHeroContent()
    .then(data => {
      dispatch(fetchHeroContentSuccess(data));
      return data;
    })
    .catch(e => {
      dispatch(fetchHeroContentError(storableError(e)));
      throw e;
    });
};

export const loadCategories = () => (dispatch, getState, sdk) => {
  dispatch(fetchCategoriesRequest());

  return fetchCategories()
    .then(data => {
      dispatch(fetchCategoriesSuccess(data));
      return data;
    })
    .catch(e => {
      dispatch(fetchCategoriesError(storableError(e)));
      throw e;
    });
};

// ================ Selectors ================ //

export const getHeroContent = state => state.sanityContent?.heroContent;
export const isHeroContentLoading = state => state.sanityContent?.fetchHeroContentInProgress;
export const getHeroContentError = state => state.sanityContent?.fetchHeroContentError;

export const getCategories = state => state.sanityContent?.categories || [];
export const getCategoryTree = state => state.sanityContent?.categoryTree || [];
export const isCategoriesLoading = state => state.sanityContent?.fetchCategoriesInProgress;
